import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        }
    };

    return axios.get(`${url}/devices`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/devices/${id}`, options)
        .then(response => {
            let device = jsona.deserialize(response.data);
            delete device.links;
            return device;
        });
}

function add(device) {
    const payload = jsona.serialize({
        stuff: device,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/devices`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(device) {
    const payload = jsona.serialize({
        stuff: device,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/devices/${device.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/devices/${id}`, options);
}

function upload(device, image) {
    const bodyFormData = new FormData();
    bodyFormData.append('attachment', image);

    return axios.post(`${url}/uploads/devices/${device.id}/profile-image`, bodyFormData)
        .then(response => {
            return response.data.url;
        });
}

function searchByPhone(params) {
    const options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, {encode: false});
        }
    };

    return axios.get(`${url}/devices/search-by-phone`, options)
        .then(response => {
            let device = jsona.deserialize(response.data);
            if (device) {
                delete device.links;
            }
            return device;
        });
}

export default {
    list,
    get,
    add,
    update,
    destroy,
    upload,
    searchByPhone
};

